var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMainCalendar = function SvgMainCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "7168.772 -8410.803 34.661 31.876",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .mainCalendar-1 {\n        fill: #fff;\n      }\n\n      .mainCalendar-2, .mainCalendar-4 {\n        fill: none;\n        stroke-miterlimit: 10;\n        stroke-width: 0.5px;\n      }\n\n      .mainCalendar-2 {\n        stroke: #585858;\n      }\n\n      .mainCalendar-3 {\n        fill: #f0f0f0;\n      }\n\n      .mainCalendar-4 {\n        stroke: #dadada;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group-25",
    transform: "translate(7169.022 -8410.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    className: "mainCalendar-1",
    d: "M-283.7,1023.785h-30.007a2.086,2.086,0,0,1-2.081-2.078v-20.039a2.087,2.087,0,0,1,2.081-2.078H-283.7a2.087,2.087,0,0,1,2.081,2.078v20.039a2.086,2.086,0,0,1-2.081,2.078",
    transform: "translate(315.79 -992.407)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    className: "mainCalendar-2",
    d: "M56.341,69.84H86.334a2.081,2.081,0,0,1,2.081,2.081V91.957a2.078,2.078,0,0,1-2.078,2.078h-30a2.078,2.078,0,0,1-2.078-2.078V71.921a2.081,2.081,0,0,1,2.081-2.081Z",
    transform: "translate(-54.257 -62.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    className: "mainCalendar-3",
    d: "M-281.629,991.706H-315.79v-8.314a1.361,1.361,0,0,1,1.358-1.352h31.442a1.361,1.361,0,0,1,1.358,1.352Z",
    transform: "translate(315.79 -979.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    className: "mainCalendar-2",
    d: "M-281.629,991.706H-315.79v-8.314a1.361,1.361,0,0,1,1.358-1.352h31.442a1.361,1.361,0,0,1,1.358,1.352Z",
    transform: "translate(315.79 -979.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    className: "mainCalendar-1",
    d: "M-290.159,980.166h0a1.252,1.252,0,0,1-1.241-1.258v-3.98a1.253,1.253,0,0,1,1.241-1.258,1.253,1.253,0,0,1,1.242,1.258v3.982a1.253,1.253,0,0,1-1.242,1.258",
    transform: "translate(298.159 -973.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-6",
    className: "mainCalendar-2",
    d: "M-290.159,980.166h0a1.252,1.252,0,0,1-1.241-1.258v-3.98a1.253,1.253,0,0,1,1.241-1.258,1.253,1.253,0,0,1,1.242,1.258v3.982A1.253,1.253,0,0,1-290.159,980.166Z",
    transform: "translate(298.159 -973.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-7",
    className: "mainCalendar-1",
    d: "M-225.768,980.166h0a1.252,1.252,0,0,1-1.242-1.258v-3.98a1.253,1.253,0,0,1,1.242-1.258,1.253,1.253,0,0,1,1.242,1.258v3.982a1.253,1.253,0,0,1-1.242,1.258",
    transform: "translate(251.613 -973.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-8",
    className: "mainCalendar-2",
    d: "M-225.768,980.166h0a1.252,1.252,0,0,1-1.242-1.258v-3.98a1.253,1.253,0,0,1,1.242-1.258,1.253,1.253,0,0,1,1.242,1.258v3.982A1.253,1.253,0,0,1-225.768,980.166Z",
    transform: "translate(251.613 -973.67)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path-9",
    className: "mainCalendar-4",
    d: "M-309.05,1033.358h29.706m-15.206-6.618v14.036m8.5-14.036v14.036m-16.813-14.036v14.036",
    transform: "translate(311.439 -1012.067)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMainCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mainCalendar.cb3b759d.svg";
export { ForwardRef as ReactComponent };